export const IbanMenCostList = [
  {
    img_src: "https://66.media.tumblr.com/99446296cd4fa69eb7de81d934463bbe/5338677d27dae8de-30/s250x400/018e28edf40ee1128133af68b232e0be1d1f2285.png",
    name: "Pakaian Lelaki Iban (Ngepan Lelaki)",
    alt: 'pakaian-lelaki-iban',
    description: "Baju Buring is the Iban's male costume. The origin of the Baju Burung is believed to be worn by brave Iban men called, 'Keling': A symbol for the Iban people that carries a meaning of strong and handsome man. Nowadays, this traditional costume is normally worn during the Gawai celebration or cultural festivities.",
  },

  {
    img_src: "https://66.media.tumblr.com/f0aa2f38229ace4143fb3dc81f6fbde5/5338677d27dae8de-fa/s540x810/7d0ab41236db1ff6214c986ecf8b5ba75a96e56b.png",
    name: "Lelanjang",
    alt: 'lelanjang',
    description: "Lelanjang is a hat made of rattan woven into beautiful patterns and embellished with feathers. Back in the days, the hornbill feathers were used. However, today, peacock feathers are used as a substitute.",
  },

  {
    img_src: "https://66.media.tumblr.com/038a6c648d92946e17ae00039a30a6d1/7c7e10a6bca870a7-a8/s540x810/2b4a986253a328ed56d80df86829b566ef616874.png",
    name: "Baju Burung",
    alt: 'baju-burung',
    description: "Baju Burung is part of the Bidayuh men's costume. The costume is woven with gold thread through 'sungkit' to make its smooth texture. The Baju Burung is usually red in colour and has the same motifs as 'Pua Kumbu'. ",
  },

  {
    img_src: "https://66.media.tumblr.com/445088da363e4e65b72e00294b431df3/7c7e10a6bca870a7-a6/s540x810/2ed8c6bde7653900e628f208689450bb2d29a71d.png",
    name: "Sirat",
    alt:'sirat',
    description: "Sirat is a piece of clothing worn by men to cover their backside down to their thighs. Back in the days, Sirat was not sewn but instead was a straight fabric.",
  },

];

export const IbanWomenCostList = [
  {
    img_src: "https://66.media.tumblr.com/12de5f674078631b87625a101fcf8323/5338677d27dae8de-7c/s540x810/cbf74b574cf06886d2320ee5624d2a3b6029c1f6.png",
    name: "Pakaian Wanita Iban (Ngepan Indu Iban)",
    alt:'pakaian-wanita-iban',
    description: "Ngepan Iban or Ngepan Indu is the traditional costume for Iban women. Women who wears the Ngepan Indu is called Kumang. The Ibans is believed to be originated from a girl named Kumang, a good person among the former Iban women.",
  },

  {
    img_src: "https://66.media.tumblr.com/84889c6eedf91cf93200d13c62d919f4/5338677d27dae8de-40/s540x810/1b7742de2eb6fd97670aaa8c7b50d192d8400ac1.png",
    name: "Sugu Tinggi",
    alt:'sugu-tinggi',
    description: "Sugu Tinggi is a headpiece made of silver. For single, unmarried women, their Sugu Tinggi should be higher as lower Sugu Tinggi is reserved for married women or widows.",
  },

  {
    img_src: "https://66.media.tumblr.com/e4114478868e858dceff8acfff877ab1/7c7e10a6bca870a7-77/s540x810/0f6bc935a4483ca7e35f8f6a33a57d17f5d5c232.png",
    name: "Tango / Marek Empang",
    alt:'marek-empang',
    description: "Marek Empang is an accessory made of beads with variety of design and patterns. It is worn as a necklace that covers the chest. ",
  },

  {
    img_src: "https://66.media.tumblr.com/03e82f47d98fe19c2419039b03238523/7c7e10a6bca870a7-41/s540x810/f5f8f86b5bc676c8885c139d09668e6e9a509ea0.png",
    name: "Pua Kumbu",
    alt:'pua-kumbu',
    description: "Pua Kumbu is the most prominent Iban weaving. It has a variety of patterns and designs. The Pua Kumbu acts as a substance in rituals such as festivals and weddings. During a wedding, the bride's parents will gifted the Pua Kumbu to the groom's family as a dowry.",
  },

  {
    img_src: "https://66.media.tumblr.com/e69851ca835af2d7f525feb6aa8daf3c/7c7e10a6bca870a7-7a/s540x810/629631028e946bddd80dbb6b214045d44b64c0d9.png",
    name: "Tumpa Bentuk",
    alt:'tumpa-bentuk',
    description: "A Tumpa is a bracelet made of copper. The Tumpa is an important accessory when wearing a traditional costume. It is deemed incomplete if a Ngepan Iban is worn without a set of Tumpa on the women's wrist. The Tumpa comes in variety of sizes.",
  },
 
  {
    img_src: "https://66.media.tumblr.com/d58022dc03840676cf8326f0a7aadac8/7c7e10a6bca870a7-24/s540x810/ec8d2a2f866a741eb3bf33b7cd6efbf286aafea3.png",
    name: "Lampit Asam",
    alt:'lampit-asam',
    description: "The traditional Iban costume would be incomplete without the Lampit. The Lampit acts as a belt to help tighten the skirt.",
  },

  {
    img_src: "https://66.media.tumblr.com/92dff9ba50c13ac5a6b031b4c376dffc/5338677d27dae8de-12/s540x810/d1b26281261bf55984b7809dcdd66149c02bc811.png",
    name: "Sementing Ringgit",
    alt:'sementing-ringgit',
    description: "Ringgit Sementing or Gobeng is an accesory worn on the hips. It is described as the belt of money.",
  },

  {
    img_src: "https://66.media.tumblr.com/c2735576dd418b9886db712496a42e40/7c7e10a6bca870a7-86/s540x810/b0ad45edd850a900b419a505f63be321c42a0b91.png",
    name: "Buah Paoh",
    alt:'buah-paoh',
    description: "Buah Paoh is an accessory made from silver. It is worn when performing the Tarian Ngajat, the traditional dance.",
  },

  {
    img_src: "https://66.media.tumblr.com/43d7a544d11568d43cb69f8332fab5dd/5338677d27dae8de-6e/s540x810/2ebfda77feadab659e583b5166b87cc58b11c3be.png",
    name: "Selampai Tenun",
    alt:'selampai-tenun',
    description: "A Selampai is a scarf worn over the shoulders as part of other traditional accessories. The Selampai is usually 1 meter in length and took 3 months in making.",
  },

  {
    img_src: "https://66.media.tumblr.com/54c1631c07fad75b1c5586bca515bee6/7c7e10a6bca870a7-66/s540x810/79216e6d4976009d10aba726d92e28915c49359e.png",
    name: "Kungkung",
    alt:'kungkung',
    description: "Kungkung or an anklet is made of metal. It has Gerunung that makes sound according to the pace of the feet movement",
  },

  {
    img_src: "https://66.media.tumblr.com/fe6135bb9bda1a5f15cf082fab7bca3c/7c7e10a6bca870a7-4b/s540x810/26ba02a822aa1146b81cc21f9429ef5d9318b12a.png",
    name: "Bidang",
    alt:'bidang',
    description: "The traditional Iban clothing also comes with a sarong called Bidang. It is a tight knee-length skirt is not limited to costume wear but is also worn daily. The Bidang has metallic accessories added on the hem of the fabric. ",
  },

  {
    name: "Ensuga",
    img_src:"https://66.media.tumblr.com/610f169ae5ece325a385e93b9be375a0/5338677d27dae8de-b2/s540x810/cb20bf490ef76f5d68c6ac9015b3695b0239fcf1.png",
    description:"Ensuga is a headgear worn by the Iban women from the region of Saratok. It is slightly different from other headgear (Sugu Tinggi) as it is more in height and floral design.",
  },

  {
    img_src:"https://66.media.tumblr.com/70eb3fabb210ef48d19512de855500f0/f0540ac695aea946-8f/s540x810/80b0c2c9f864d924824464f7d94d377b9b98af94.png",
    name:"Tali Ujan/ Mulung", 
    alt:'tlai-ujan',
    description: "Tali Ujan is a beaded “tail” hung at the back of the ngepan which would normally have cow bells that will hit the wearers ankles to alarm the people that a Kumang is coming.",
  },

  {
    img_src:"https://66.media.tumblr.com/d44e85c0637d263b72f030f326a3b81e/f0540ac695aea946-d6/s540x810/3e7171683a0fa383e3988333a71e152b8bf70739.png",
    name:"Rawai",
    alt:'rawai',
    description:"Rawai is a corset made of silver and brass. There are two types of Rawai: a low corsetted ones (Rawai Pandak) and a high corset (Rawai Tinggi). Rawai Tinggi measures from the chest to the waist.",
  },

  { 
    img_src:"https://66.media.tumblr.com/3d95fdb05c5b4fb87632bd31942accdc/7c7e10a6bca870a7-f9/s540x810/ebd1e36e3037b7f77c09850b24720ddd75c5c4c9.png",
    name: "Lampit",
    alt:'lampit',
    description:"Lampit is a silver belt worn on a woman's waist. A 'Ngepan Indu Iban' would be incomplete without the Lampit.",

  },

  {
    img_src:"https://66.media.tumblr.com/3d95fdb05c5b4fb87632bd31942accdc/7c7e10a6bca870a7-f9/s540x810/ebd1e36e3037b7f77c09850b24720ddd75c5c4c9.png",
    name: "Dujung Marik",
    alt:'dujung-marik',
    description:"Dujung Marik is a headgear from the Iban community from the Kapit region. Unlike the other Iban women's headwears, the Dujung Marik headgear is decorated with seed beads, brass button bells and wollen threads.",
  },

];